import { Button, Form, FormInstance, Input } from 'antd';
import { Lock, User } from 'lucide-react';
import React from 'react';


const { Item } = Form;

interface LoginFormProps {
    form: FormInstance<{
        account: string;
        password: string;
    }>;
    onFinish: (values: { account: string; password: string }) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ form, onFinish }) => {
    return (
        <Form form={form} onFinish={onFinish}>
            <Item
                name="account"
                rules={[{ required: true, message: '请输入账号!' }]}
            >
                <Input prefix={<User size={20} />} placeholder="账号" />
            </Item>
            <Item
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
            >
                <Input.Password prefix={<Lock size={18} />} placeholder="密码" />
            </Item>
            <Item>
                <div className="flex justify-between gap-4 w-full">
                    <Button
                        type="default"
                        htmlType="reset"
                        className="w-full"
                    >
                        重置
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="w-full"
                    >
                        登录
                    </Button>
                </div>
            </Item>
        </Form>
    );
};

export default LoginForm;